import { z } from "zod";

// ── Reasoning Phase ────────────────────────────────────────────

export const reasoningPhaseEnum = z.enum([
  "generating_queries",
  "searching_knowledge",
  "synthesizing",
  "done",
]);

export type ReasoningPhase = z.infer<typeof reasoningPhaseEnum>;

// ── Top Source (shown in knowledge_retrieved) ──────────────────

export const reasoningTopSourceSchema = z.object({
  name: z.string(),
  authorityLevel: z.string(),
});

export type ReasoningTopSource = z.infer<typeof reasoningTopSourceSchema>;

// ── Reasoning Event (discriminated union) ──────────────────────

export const reasoningEventSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("phase_change"),
    phase: reasoningPhaseEnum,
  }),
  z.object({
    type: z.literal("queries_generated"),
    queries: z.array(z.string()),
  }),
  z.object({
    type: z.literal("knowledge_retrieved"),
    chunkCount: z.number(),
    sourceCount: z.number(),
    topSources: z.array(reasoningTopSourceSchema),
  }),
  z.object({
    type: z.literal("partial_result"),
    kind: z.string(),
    data: z.unknown(),
  }),
  z.object({
    type: z.literal("done"),
    summary: z.string(),
  }),
  z.object({
    type: z.literal("error"),
    message: z.string(),
  }),
]);

export type ReasoningEvent = z.infer<typeof reasoningEventSchema>;

// ── Callback type ──────────────────────────────────────────────

export type ReasoningEventCallback = (event: ReasoningEvent) => void;
